// Imports ------------------------------------------------------------------->

import {AuthProvider, AccountsUser} from "../../definitions/CommonDefinitions";

// Private Definitions ------------------------------------------------------->

// Public Definitions -------------------------------------------------------->

export interface LoginState {
	provider: AuthProvider;
	path: string;
}

/* Interface representing a user in the auth provider (eg FB or Google) */
export interface AuthProviderUser {
	id: string;
	name?: string;
	email?: string;
	image?: string;
	accessToken?: string;
	expiresAt?: number;
	provider: AuthProvider;
}

/* Type representing user in the Flipp ecosystem. Should contain user info from the auth provider, with
 * optionally info from the Flipp accounts system */
export type AuthUser = {
	info: AuthProviderUser,
	token?: AccountsUser
};

/* Enum of the different authentication states */
export enum AuthStatus {
	LOGGED_IN,
	LOGGED_OUT
}

export interface IAuthenticationService {
	status: AuthStatus;
	user: AuthUser;
	init: (state?: any) => Promise<void>;
	login: (source: AuthProvider, target?: EventTarget) => Promise<void>;
	logout: (target?: EventTarget) => Promise<void>;
}
